export default function (context) {
    let state = context.state;
    if (state.loading) return;
    context.commit('loading', true);

    axios({
        method: 'post',
        url: '/tourclient/MasterAgent/Dictionary/WebReport/List',
        data: 'request=' + JSON.stringify({})
    }).then(({data}) => {
        let error = '';
        if (!data) {
            error = 'Не удалось загрузить справочник: Отчеты';
        } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
            error = data.ResultQueryInfo.UserMessages;
        }
        if (error) {
            window.app.$notify.error({
                title: 'Ошибка',
                message: error,
            });
        }
        context.commit('items', data.Items);

    }).catch(e => {
        if (!e) return;
        context.commit('items');
        context.dispatch('error', e, {root: true});
    });
}